const SpinnerLoader = ({
  color = '#fff',
  scale = 1,
}: {
  color?: string;
  scale?: number;
}) => (
  <>
    <span className="spinner-loader"></span>
    <style jsx>{`
      .spinner-loader {
        width: ${20 * scale}px;
        height: ${20 * scale}px;
        border: ${1.5 * scale}px solid ${color};
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
      }

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}</style>
  </>
);

export default SpinnerLoader;
